import React, { useState } from "react";
import { Lightning } from "@phosphor-icons/react";
import { Input } from "../components/ui/input";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
    } catch (e) {
      const detail = e.response?.data?.detail;
      if (typeof detail === "string") setError(detail);
      else if (Array.isArray(detail)) setError(detail.map((d) => d.msg || d).join(" "));
      else setError("Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#F5F5F7]"
      data-testid="login-page"
    >
      <div className="w-full max-w-sm">
        <div className="bg-white border border-border p-8">
          <div className="flex items-center gap-2 mb-6">
            <Lightning weight="bold" size={26} className="text-[#002FA7]" />
            <span
              className="text-2xl font-bold tracking-tight"
              style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}
            >
              BlitzWeb
            </span>
          </div>

          <h2
            className="text-lg font-bold tracking-tight mb-1"
            style={{ fontFamily: "Cabinet Grotesk, sans-serif" }}
          >
            Sign In
          </h2>
          <p className="text-xs text-[#52525B] mb-6">
            Enter your credentials to access the dashboard
          </p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs font-bold uppercase tracking-[0.15em] text-[#52525B] block mb-1">
                Email
              </label>
              <Input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@blitzweb.io"
                className="border-border rounded-none focus:border-[#002FA7] focus:ring-0"
                required
              />
            </div>
            <div>
              <label className="text-xs font-bold uppercase tracking-[0.15em] text-[#52525B] block mb-1">
                Password
              </label>
              <Input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                className="border-border rounded-none focus:border-[#002FA7] focus:ring-0"
                required
              />
            </div>

            {error && (
              <div
                data-testid="login-error"
                className="text-xs font-semibold text-[#FF2A00] bg-[#FEE2E2] px-3 py-2 border border-[#FF2A00]"
              >
                {error}
              </div>
            )}

            <button
              data-testid="login-submit-btn"
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-[#002FA7] text-white text-sm font-semibold hover:bg-[#002482] transition-colors disabled:opacity-50"
            >
              {loading ? (
                <div
                  className="spinner"
                  style={{
                    borderTopColor: "white",
                    borderColor: "rgba(255,255,255,0.3)",
                  }}
                />
              ) : (
                "Sign In"
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
